<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :disabled="disabled"
            :multiple="multiple"
            :autoComplete="autoComplete"
            :dense="dense"
            @clearSelected="$emit('clearSelected')"
            :outlined="outlined"
        />
        <sys-register-base-group @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectBaseGroup',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        selectedObject: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        modelObject: {
        
        },
        dense: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        autoComplete: {
            type: Boolean,
            default: false
        },
        courseId: {
            required: true
        },
        campusId: {
            required: true
        },
        shiftId: {
            required: true
        },
        outlined: {
            type: Boolean,
            default: false
        }
        
    },
    watch: {
        
        selected(val){
            
            if(val){
                this.$emit('update:model', val);
                
                var item = this.items.find(c => c.id == val);

                if(item) {
                    this.$emit('update:modelObject', item);
                }else{
                    this.$emit('update:modelObject', null);
                }
            }
        },

        selectedObject(val){
            this.$emit('update:modelObject', val);
        },
        
        model(val){
            this.selected = val;
        },

        courseId(){
            this.getItems();
        },

        campusId(){
            this.getItems();
        },

        shiftId(){
            this.getItems();
        },

        modelObject(val){
            this.selectedObject = val;
            
            if(val && val.id){
                this.selected = val.id;
            }else{
                 this.selected = 0;
            }
        },
    },
    methods: {
        ...mapActions('baseGroup', ['ActionFindBaseGroups']),        
        
        async getItems() {

            if(!this.courseId || !this.campusId || !this.shiftId){
                return;
            }
            
            this.loading = true;

            var payload = {
                find_columns: {
                    course_id: this.courseId,
                    campus_id: this.campusId,
                    shift_id: this.shiftId,
                    active: 1
                }
            };

            await this.ActionFindBaseGroups(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                        this.$emit('onLoad', this.items);
                       
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

        newItem(item){
        
            if(item){
                
                this.items.push(item);
                
                if(this.multiple){
                    
                    if(!this.selected){
                        this.selected = [];
                    }

                    this.selected.push(item);
                }else{
                    this.selected = item.id;
                    this.selectedObject = item;
                }
                
                    this.showForm = false;

                }
        }
    },
    
}
</script>